export const FONTS = [
  'Press Start 2P',
  'Roboto:400,700',
  'Orbitron:400,700', 
  'Noto Sans JP:400,700',
  'Quicksand:400,500,700',
  'Montserrat:400,700,800',
  'Poppins:400,500,600',
  'Cormorant Garamond:400,500,600'
]
